document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function (event) {
  customJS.init(); // run custome code
});

var addToCartBtn, engravingTab, productUnavailable, actions, $custom;
const selectedOptions = new Map();
// const querystring = '?type=customproduct&0=0_15&1=1_2&2=0_13&3=0_4&4=1_5&5=0_6&6=1_7';
const querystring = window.location.search;
const params = new URLSearchParams(querystring);

if (querystring.includes("type=customproduct")) {
  for (const pair of params.entries()) {
    if (!pair[0].includes("type")) {
      console.log(pair[0] + ", " + pair[1]);
      const arr = pair[1].split("_");
      selectedOptions.set(parseInt(pair[0]), arr);
    }
  }
}

let clickFactory;
let reactTabs;
const changedTabs = new Set();

var customJS = {
  init: function () {
    const _this = this;
    //   this.initGlobals();
    const addToCartBtn = document.querySelector(".cpb-add-to-cart-button");
    const productUnavailable = document.querySelector("#product-unavailable");
    const actions = document.querySelector(".cpb-product-actions-container");
    const engravingTab = document.querySelector(".js_engraving-tab");
    /* Go to the admin panel of each custom product --> 
                                                      Click on engraving tab --> 
                                                      Tab Settings (Edit This Tab) --> 
                                                      find 'Extra Class Name For Tab' field --> 
                                                      add class name 'js_engraving-tab'
                                                  */
    this.watchTabs(addToCartBtn, productUnavailable, engravingTab);
    this.createUnavailableButton(productUnavailable, actions);
    this.insertIcon();
    if (selectedOptions.size != 0) {
      clickFactory = this._clickFactory(selectedOptions);
      this.automateClick(selectedOptions, 0);
    }
  },
  // initGlobals: function () {
  //   const addToCartBtn = document.querySelector('.cpb-add-to-cart-button');
  //   const productUnavailable = document.querySelector('#product-unavailable');
  //   const actions = document.querySelectorAll('.cpb-product-actions-container');
  //   const engravingTab = document.querySelector('.js_engraving-tab');
  //                                         /* Go to the admin panel of each custom product -->
  //                                              Click on engraving tab -->
  //                                              Tab Settings (Edit This Tab) -->
  //                                              find 'Extra Class Name For Tab' field -->
  //                                              add class name 'js_engraving-tab'
  //                                          */
  // },
  watchTabs: function (addToCartBtn, productUnavailable, engravingTab) {
    if (productUnavailable) return;
    document.body.addEventListener(
      "CPB_ON_UPDATE_CURRENT_TAB",
      function (event) {
        if (event.detail.selectPanelID == "summary") {
          customJS._validateEngraving(addToCartBtn, engravingTab);
        } else {
          customJS._hideAddToCartBtn(addToCartBtn);
        }
        console.log(`index: ${event.detail.currentIndex}`);
        if (event.detail.currentIndex <= selectedOptions.size) {
          console.log(`index: ${event.detail.currentIndex}`);
          customJS.automateClick(selectedOptions, event.detail.currentIndex);
        }
      }
    );
  },
  createUnavailableButton: function (productUnavailable, actions) {
    if (productUnavailable) {
      const buttons = Array.from(actions.querySelectorAll("button"));
      buttons.forEach((button) => button.remove());
      actions.appendChild(productUnavailable);
    }
  },
  insertIcon: function () {
    document.addEventListener("click", (e) => {
      const input_element = document.querySelector(".engraving-input");
      if (input_element) {
        const event = e.target;
        const input = input_element.querySelector("input");
        if (event.classList.contains("icon-button")) {
          e.preventDefault();
          if (input.value.length < 3) {
            let x = "";
            let value = "";
            if (event.innerHTML === "&amp;") {
              x = "&";
            } else {
              x = event.innerHTML;
            }
            // $(input).val($(input).val() + x);
            value = input.value + x;
            setInputValue(input, value);
            input.dispatchEvent(new Event("input", { bubbles: true }));
            const firstChild = document.querySelector(
              ".cpb-option-insert-character-count:first-child"
            );
            firstChild.childNodes[0].textContent = `${input.value.length}`;
          }
        }
      }
    });

    function setInputValue(element, value) {
      var valueSetter = Object.getOwnPropertyDescriptor(element, "value").set;
      var prototype = Object.getPrototypeOf(element);
      var prototypeValueSetter = Object.getOwnPropertyDescriptor(
        prototype,
        "value"
      ).set;

      if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
      } else {
        valueSetter.call(element, value);
      }
    }
  },
  automateClick: function (selectedOpions, index) {
    if (!changedTabs.has(index)) {
      console.log(index);
      console.log(changedTabs);
      changedTabs.add(index);
      reactTabs = document.querySelector(".react-tabs__tab-list").childNodes;
      target = document.querySelector(".cpb-panel-categories-container");
      clickFactory.observe(target);
      // clickFactory.leatherClick(index);
      clickFactory.leatherClick();
    }
  },
  _showAddToCartBtn: function (addToCartBtn) {
    addToCartBtn.style.display = "inline-block";
  },
  _hideAddToCartBtn: function (addToCartBtn) {
    addToCartBtn.style.display = "none";
  },
  _validateEngraving: function (addToCartBtn, engravingTab) {
    //   var engraving = $('.cpb-selection-summary-list-item-category-title:contains("刻印文字")');
    const engravingItems = document.querySelectorAll(
      ".cpb-selection-summary-list-item-category-title"
    );
    let engraving;
    for (let i = 0; i < engravingItems.length; i++) {
      if (engravingItems[i].textContent.includes("刻印文字")) {
        engraving = engravingItems[i];
        break;
      }
    }

    if (engraving && engravingTab) {
      var regex = new RegExp("^[A-Z0-9.♡☆&]+$");
      const siblingElements = Array.from(engraving.parentNode.children).filter(
        (el) => el !== engraving
      );
      const engravingValue = siblingElements
        .map((el) => el.innerHTML.replaceAll("&amp;", "&"))
        .join("")
        .trim();
      // engravingValue = engraving.siblings().html().replaceAll('&amp;', '&');
      if (!regex.test(engravingValue)) {
        var r = confirm(
          "8.イニシャル刻印に適用できる文字は「A~Z (大文字のみ), 0-9, ☆, ♡, ＆,  .(ピリオド)」のいずれかです。"
        );
        if (r == true) {
          engravingTab.click();
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      } else {
        customJS._showAddToCartBtn(addToCartBtn);
      }
    } else {
      customJS._showAddToCartBtn(addToCartBtn);
    }
  },
  _buttonclick: function (selector) {
    selector.click();
  },
  _clickFactory: function (selectedOptions) {
    let num = 0;
    let panelindex = 0;
    let colorSelected = false;
    return {
      parentTabClick: function (reactTabs) {
        console.log(panelindex);
        reactTabs[panelindex].click();
      },
      leatherClick: function () {
        // num = number;
        console.log(`.leather-${num + 1}`);
        const leatherTypeToSelect = selectedOptions.get(num)[0];
        const leatherParent = document.querySelector(`.leather-${num + 1}`);
        console.log(leatherParent);

        if (leatherParent || leatherParent != undefined) {
          const leathers = leatherParent.querySelector("div:nth-child(2)");
          const leather = leathers.querySelector("div:nth-child(2)");

          const childElements = [...leather.children];
          let isLeatherSelected = false;
          for (let child of childElements) {
            if (child.classList.contains("active")) {
              console.log("active クラスが付与されています");
              isLeatherSelected = true;
              // const colorToSelect = selectedOptions.get(num)[1];
              // console.log(colorToSelect);

              // const colorOptions = document.querySelectorAll('.cpb-category-options-container')[1];
              // const options = colorOptions.querySelectorAll('.cpb-option');
              // console.log(options);
              // options.forEach(option => option.classList.remove('cpb-active')); // すべての選択を解除

              // setTimeout( () => {
              //   options[colorToSelect].click(); // 新しい選択を適用
              // }, 100);
            }
          }

          if (isLeatherSelected) {
            const colorToSelect = selectedOptions.get(num)[1];
            console.log(colorToSelect);
            const colorOptions = document.querySelectorAll(
              ".cpb-category-options-container"
            )[1];
            const options = colorOptions.querySelectorAll(".cpb-option");
            colorSelected = true;
            options[colorToSelect].click();
          }

          if (!isLeatherSelected) {
            const toBeSelected =
              leather.children[leatherTypeToSelect].firstChild;
            toBeSelected.click();
            // setTimeout( () => {
            //   toBeSelected.click();
            // }, 5);
          }
          // const leather = leatherParent.querySelector("div:nth-child(2)")
          //                 .querySelector("div:nth-child(2)").children[leatherTypeToSelect].firstChild;
          //         setTimeout(() => {
          //           leather.click();
          //         }, 5);
        } else {
          panelindex += 1;
          reactTabs[panelindex].click();
          // setTimeout( () => {
          //   reactTabs[panelindex].click();
          // }, 2000)
        }
      },
      colorClick: function (mutations, observer) {
        console.log(mutations);
        if (mutations.length > 0) {
          observer.disconnect();
          setTimeout(() => {
            const colorToSelect = parseInt(selectedOptions.get(num)[1]) + 1;
            console.log(`colorToSelect: ${colorToSelect}`);

            if (!colorSelected) {
              mutations[colorToSelect].addedNodes[0].click();
            }

            num += 1;
            panelindex += 1;
            console.log(panelindex);
            clickFactory.parentTabClick(reactTabs);
          }, 100);

          // num += 1;
          // setTimeout( () => {
          //   clickFactory.parentTabClick(reactTabs);
          // }, 2000)
        }
      },
      observe: function (target, index) {
        let panelindex = index;
        const observer = new MutationObserver(clickFactory.colorClick);
        observer.observe(target, {
          childList: true,
          subtree: true,
          attributes: false,
        });
      },
    };
  },
};
